import AsyncReactSelect from '@atlaskit/react-select/async';

import createSelect from './create-select';

const AsyncSelect = createSelect(AsyncReactSelect);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default AsyncSelect;
